<template>
    <div id="risk-profile-information" class="tab-pane fade">
        <div class="row">
            <div class="col-md-12"><p>Not available.</p></div>
        </div>
    </div>
</template>

<script>
	export default {
		props: []
	};
</script>